import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const { exportManager } = config.endpoints

const exportConversation = (data) => axios({
  method: 'post',
  url: exportManager.exportConversation,
  data,
  headers: getHeaders(true)
})

export default {
  exportConversation
}